import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './ButtonBase.less';

/**
 * BaseButton
 *
 */

function ButtonBase({
    block,
    children,
    className,
    href,
    inverse,
    label,
    size,
    srOnlyLabel,
    ...rest
}) {
    const buttonClasses = classNames('btn', className, {
        'btn-inverse': inverse,
        'btn-block': block,
        [`btn-${size}`]: size
    });
    const labelClasses = classNames('btn__label', {
        'sr-only': srOnlyLabel
    });

    if (href) {
        return (
            <a className={buttonClasses} href={href} {...rest}>
                <span className={labelClasses}>{label}</span>
                {children}
            </a>
        );
    }
    return (
        <button className={buttonClasses} {...rest}>
            <span className={labelClasses}>{label}</span>
            {children}
        </button>
    );
}


ButtonBase.propTypes = {
    /** Flags for if the button is .btn-block (span the full width of a parent) */
    block: PropTypes.bool,
    /** Flag for if the button is disabled */
    disabled: PropTypes.bool,
    /** If href is specified, the component outputs an <a> tag,
     * otherwise, it is a button tag. */
    href: PropTypes.string,
    /** Flag for if the button is is inverse-styled and receives className .btn-inverse */
    inverse: PropTypes.bool,
    /** The text or html to display on the button, required. */
    label: PropTypes.node.isRequired,
    /** Size variation from Baseline. (xl variant is only for EG theme) */
    size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
    /** Flag for applying .sr-only class to the button label for Screen Readers */
    srOnlyLabel: PropTypes.bool,
    /** Specify the type of button. One of: 'button'|'submit'|'reset' */
    type: PropTypes.oneOf(['button', 'submit', 'reset'])
};

ButtonBase.defaultProps = {
    type: 'button',
};

export default ButtonBase;
